var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.3309 7.44275C20.9119 7.17879 20.3969 7.15544 19.9579 7.37879L18.4759 8.12701C17.9279 8.40316 17.5879 8.96153 17.5879 9.58285V15.4164C17.5879 16.0377 17.9279 16.595 18.4759 16.8732L19.9569 17.6204C20.1579 17.724 20.3729 17.7737 20.5879 17.7737C20.8459 17.7737 21.1019 17.7006 21.3309 17.5575C21.7499 17.2945 21.9999 16.8387 21.9999 16.3392V8.66204C21.9999 8.16255 21.7499 7.70671 21.3309 7.44275Z",
    fill: "#7B27F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9051 20H6.11304C3.69102 20 2 18.3299 2 15.9391V9.06091C2 6.66904 3.69102 5 6.11304 5H11.9051C14.3271 5 16.0181 6.66904 16.0181 9.06091V15.9391C16.0181 18.3299 14.3271 20 11.9051 20Z",
    fill: "#7B27F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.8c3fcf158a7ea58816fff68cb0a74cdb.svg";
export { ForwardRef as ReactComponent };